export default __webpack_public_path__ + "static/media/K.19059220.svg";